// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3752":"36fc960a","4735":"36fc960a","6481":"36fc960a","7811":"36fc960a"}[chunkId] + ".chunk.css";
};